"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _clsx = _interopRequireDefault(require("clsx"));

var _styles = require("@material-ui/core/styles");

var _pickReactKnownProp = require("pick-react-known-prop");

var _useTranslate = _interopRequireDefault(require("@sprinx/react-globalize/useTranslate"));

var _ProductImgList = _interopRequireDefault(require("../../../components/ProductImgList"));

var _useShoppingCurrency = _interopRequireDefault(require("../../../shop/useShoppingCurrency"));

var _ProductDetailSectionTitleAlternatives = _interopRequireDefault(require("./ProductDetailSectionTitleAlternatives"));

var _useProductReplacementProducts = _interopRequireDefault(require("./useProductReplacementProducts"));

//
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      maxWidth: '100%',
      paddingTop: theme.spacing(2),
      paddingBottom: theme.spacing(2)
    },
    title: (0, _defineProperty2.default)({
      fontWeight: 300,
      fontSize: 28,
      textTransform: 'none',
      color: theme.palette.text.primary,
      textDecoration: 'none'
    }, theme.breakpoints.down('sm'), {
      fontSize: 23
    }),
    titleSection: {
      fontWeight: 400,
      marginRight: theme.spacing(1),
      textTransform: theme.text.textTransformUppercase
    }
  };
}, {
  name: 'ProductDetailReplacementProducts'
});

function ProductDetailReplacementProducts(_ref) {
  var pClasses = _ref.classes,
      className = _ref.className,
      product = _ref.product,
      rest = (0, _objectWithoutProperties2.default)(_ref, ["classes", "className", "product"]);
  var classes = useStyles({
    classes: pClasses
  });
  var t = (0, _useTranslate.default)();
  var currency = (0, _useShoppingCurrency.default)();
  var replacementProducts = (0, _useProductReplacementProducts.default)(product.id);
  return replacementProducts.length > 0 ? /*#__PURE__*/_react.default.createElement("div", (0, _extends2.default)({}, (0, _pickReactKnownProp.pickHTMLProps)(rest), {
    className: (0, _clsx.default)(classes.root, className)
  }), /*#__PURE__*/_react.default.createElement(_ProductImgList.default, {
    title: /*#__PURE__*/_react.default.createElement("div", {
      className: classes.title
    }, /*#__PURE__*/_react.default.createElement("span", {
      className: classes.titleSection
    }, t('productReplacementProducts')), t(product.name)),
    classes: {
      title: classes.title
    },
    TitleComponent: _ProductDetailSectionTitleAlternatives.default,
    products: replacementProducts,
    currency: currency
  })) : null;
}

process.env.NODE_ENV !== "production" ? ProductDetailReplacementProducts.propTypes = {
  classes: _propTypes.default.shape({
    root: _propTypes.default.string,
    title: _propTypes.default.string,
    titleSection: _propTypes.default.string
  }),
  className: _propTypes.default.string,
  product: _propTypes.default.shape({
    id: _propTypes.default.string.isRequired,
    name: _propTypes.default.arrayOf(_propTypes.default.shape({})).isRequired
  }).isRequired
} : void 0;
ProductDetailReplacementProducts.defaultProps = {
  classes: undefined,
  className: undefined
};
var _default = ProductDetailReplacementProducts;
exports.default = _default;